import React from 'react'
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'
import { skSK as dataGridSkSK } from '@mui/x-data-grid'
import { skSK as coreSkSK } from '@mui/material/locale'
import useSettings from '../../hooks/useSettings'
import { merge } from 'lodash'

const MatxTheme = ({ children }) => {
	const { settings } = useSettings()

	const activeTheme = createTheme({
		...settings.themes[settings.activeTheme]
	})

	const theme = createTheme({
		...activeTheme,
		components: merge(activeTheme.components, dataGridSkSK?.components, coreSkSK?.components)
	})

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	)
}

export default MatxTheme
